const RestaurantCard = ({ fields, imgUrl, id }) => {
    return (
        <span className="">
            {
                imgUrl
                    ?
                    <img src={imgUrl} className="" alt="restaurant img" />
                    :
                    <div></div>
            }
            <h3 className="font-semibold mb-1">{fields?.name}</h3>
            <p className="">{fields?.location}</p>
            <hr className="my-4"/>
            <p className="">{(fields?.cuisine)?.join(", ") + " • " + (fields?.category)?.join(", ")}</p>
        </span>
    )
}

export default RestaurantCard;